import React, {useState} from 'react'
import Select from 'react-select'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from '@packages/apollo-hooks'
import gql from 'graphql-tag'

import {LocalLegalInformation} from '../LegalInformation/LocalLegalInformation'

import styles from './styles.module.css'
export default function LegalInformation(props) {
  const websiteId = props.website._id
  const [legalInformationToView, setLegalInformationToView] = useState(null)
  const {data} = useApolloQuery({
    query: gql`
      query GetTradeNames($websiteId: ID) {
        getTradeNames(websiteId: $websiteId) {
          _id
          name
          rut
          address
          phone
          email
          legalRepName
          legalRepRut
          storeIds
        }
        stores(websiteId: $websiteId) {
          items {
            _id
            name
          }
        }
        website(websiteId: $websiteId) {
          _id
          name
          logo {
            _id
            url: resizedURL(height: 200, format: "webp")
          }
        }
      }
    `,
    variables: {websiteId},
    omit: isServerSide(),
    partial: true
  })

  const {getTradeNames: legalInformation, stores, website} = data

  const getLocals = () => {
    return stores?.items.map(store => ({value: store._id, label: store.name}))
  }

  const handleLegalData = e => {
    if (e) {
      const [legalDataForLocal] = legalInformation.filter(legal => {
        return legal.storeIds.includes(e.value)
      })
      if (legalDataForLocal) {
        const {address, email, legalRepName, legalRepRut, name, phone, rut} = legalDataForLocal
        setLegalInformationToView({address, email, legalRepName, legalRepRut, name, phone, rut})
      } else {
        setLegalInformationToView(null)
      }
    } else {
      setLegalInformationToView(null)
    }
  }
  return (
    <div className={styles.container}>
      <h3>Identificación de Locales</h3>
      <div className={styles.content}>
        <p>Selecciona un Local</p>
        <Select options={getLocals()} onChange={handleLegalData} />
        <br />
        {legalInformationToView ? (
          <LocalLegalInformation
            companyName={website.name}
            imageURL={website.logo?.url}
            legalInformationToView={legalInformationToView}
          />
        ) : null}
      </div>
    </div>
  )
}
